"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAsyncPersistedState = exports.createPersistedState = void 0;
const create_persisted_state_1 = __importDefault(require("./create-persisted-state"));
Object.defineProperty(exports, "createPersistedState", { enumerable: true, get: function () { return create_persisted_state_1.default; } });
const create_async_persisted_state_1 = __importDefault(require("./create-async-persisted-state"));
exports.createAsyncPersistedState = create_async_persisted_state_1.default;
const is_async_storage_1 = __importDefault(require("./utils/is-async-storage"));
function createPersistedState(name, storage) {
    if ((0, is_async_storage_1.default)(storage)) {
        return (0, create_async_persisted_state_1.default)(name, storage);
    }
    return (0, create_persisted_state_1.default)(name, storage);
}
exports.default = createPersistedState;
//# sourceMappingURL=index.js.map